<script>
  import './index.scss';
  import { onMount } from "svelte";

  onMount(async () => {
    // START JS NAVBAR HAMBURGER
    // Get all "navbar-burger" elements
    let _navbarBurgers = Array.prototype.slice.call(
      document.querySelectorAll(".navbar-burger"),
      0
      );
    // Check if there are any navbar burgers
    if (_navbarBurgers.length > 0) {
      // Add a click event on each of them
      _navbarBurgers.forEach(function(_el) {
        _el.addEventListener("click", function() {
          // Get the target from the "data-target" attribute
          let target = _el.dataset.target;
          let _target = document.getElementById(target);

          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          _el.classList.toggle("is-active");
          _target.classList.toggle("is-active");
        });
      });
    }
    document.querySelectorAll(".navbar-link").forEach(function(navbarLink) {
      navbarLink.addEventListener("click", function() {
        navbarLink.nextElementSibling.classList.toggle("is-hidden-mobile");
      });
    });
    // END JS NAVBAR HAMBURGER
  });
</script>

<nav class="navbar is-black" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <p class="navbar-item has-text-weight-bold">
      BRIEF BURGER v.1.0.0
    </p>

    <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicExample" class="navbar-menu">
    <div class="navbar-start">
    </div>

    <div class="navbar-end">
    </div>
  </div>
</nav>